//libs\components\modal\src\lib\ui-modal-global\modal-global.component.ts
import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';

export type ModalGlobalSize = 'sm' | 'md' | 'lg';
export type ModalGlobalTone = 'default' | 'danger-soft';
export type ModalGlobalButtonTone = 'primary' | 'ghost' | 'danger';

export interface ModalGlobalButton {
  id: string;
  label: string;
  tone?: ModalGlobalButtonTone;
  iconClass?: string;
  disabled?: boolean;
  closeOnClick?: boolean;
  ariaLabel?: string;
}


@Component({
  selector: 'lib-modal-global',
  templateUrl: './modal-global.component.html',
  styleUrl: './modal-global.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalGlobalComponent {
  readonly open = input<boolean>(false);
  readonly title = input.required<string>();
  readonly description = input<string | null>(null);

  readonly size = input<ModalGlobalSize>('md');
  readonly tone = input<ModalGlobalTone>('default');

  readonly closeOnBackdrop = input<boolean>(true);
  readonly closeOnEscape = input<boolean>(true);
  readonly showCloseButton = input<boolean>(true);

readonly showFooter = input<boolean>(true);
readonly hasFloatingContent = input<boolean>(false);
readonly buttons = input<readonly ModalGlobalButton[]>([]);

  readonly closed = output<void>();
  readonly buttonPressed = output<string>();

  @HostListener('document:keydown.escape')
  protected onEscapeKey(): void {
    if (!this.open() || !this.closeOnEscape()) {
      return;
    }

    this.close();
  }

  protected onBackdropClick(): void {
    if (!this.open() || !this.closeOnBackdrop()) {
      return;
    }

    this.close();
  }

  protected onDialogClick(event: Event): void {
    event.stopPropagation();
  }

  protected onButtonClick(button: ModalGlobalButton): void {
    if (button.disabled) {
      return;
    }

    this.buttonPressed.emit(button.id);

    if (button.closeOnClick) {
      this.close();
    }
  }

  protected close(): void {
    this.closed.emit();
  }
}
